var React = require('react');

function Mappin (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Map pin icon"),React.createElement("path",{"d":"M104.5 15.6c-34.7 0-62.8 28.1-62.8 62.8 0 2.7.2 5.2.5 7.8 5.4 49.1 58.2 105.6 58.2 105.6.9 1.1 1.8 1.7 2.7 2.2l1.8.6 1.8-.6c.9-.5 1.8-1.2 2.7-2.2 0 0 52.1-56.7 57.3-105.7.3-2.5.5-5.1.5-7.7.1-34.7-28.1-62.8-62.7-62.8zm0 103.2c-22.3 0-40.4-18.1-40.4-40.4S82.2 38 104.5 38s40.4 18.1 40.4 40.4-18.2 40.4-40.4 40.4z","key":1})]);
}

Mappin.defaultProps = {"id":"googleplus-svg","viewBox":"0 0 210.9 210.9"};

module.exports = Mappin;

Mappin.default = Mappin;
